import api from 'app/shared/utils/api';
import promise from 'promise';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import ReviewsForListing from 'app/shared/model/ReviewsForListing';
import Review from 'app/shared/model/Review';

const LeadActions = {
    getReviewsForListing(params = {}, appendToReviews = false) {
        return dispatch => dispatch(api.users.reviews.reviewsForListing(params))
            .then((result) => {
                if (result.success) {
                    const reviewsForListing = ReviewsForListing(result.response);

                    return dispatch({
                        type: DispatchConstants.REVIEWS_FOR_LISTING_GET_SUCCESS,
                        payload: { reviewsForListing, appendToReviews },
                    });
                }
                return promise.reject(result.error);
            });
    },
    reportReview(params = {}) {
        return dispatch => dispatch(api.users.reviews.report(params))
            .then((result) => {
                if (result.success) {
                    const review = Review(result.response);

                    return dispatch({
                        type: DispatchConstants.REVIEW_REPORT_SUCCESS,
                        payload: { review },
                    });
                }
                return promise.reject(result.error);
            });
    },
    createResponse(params = {}) {
        return dispatch => dispatch(api.users.reviews.response.create(params))
            .then((result) => {
                if (result.success) {
                    const review = Review(result.response);

                    return dispatch({
                        type: DispatchConstants.REVIEW_RESPONSE_UPDATE_SUCCESS,
                        payload: { review },
                    });
                }
                return promise.reject(result.error);
            });
    },
    updateResponse(params = {}) {
        return dispatch => dispatch(api.users.reviews.response.update(params))
            .then((result) => {
                if (result.success) {
                    const review = Review(result.response);

                    return dispatch({
                        type: DispatchConstants.REVIEW_RESPONSE_UPDATE_SUCCESS,
                        payload: { review },
                    });
                }
                return promise.reject(result.error);
            });
    },
    deleteResponse(params = {}) {
        return dispatch => dispatch(api.users.reviews.response.delete(params))
            .then((result) => {
                if (result.success) {
                    return dispatch({
                        type: DispatchConstants.REVIEW_RESPONSE_DELETE_SUCCESS,
                        payload: params,
                    });
                }
                return promise.reject(result.error);
            });
    },
};

export default LeadActions;
